import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import { FaPlus } from 'react-icons/fa6';
import { FiMinus } from 'react-icons/fi';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import { Button, Tooltip } from 'antd'
import { CopyOutlined } from '@ant-design/icons';


const BillingBlock = ({ bookingId, unUtilizedFee, idleDuration, unUtilizedTimeSec, billingDataProp }) => {
  // console.log('billingDataProp', billingDataProp);
  const [ariaExpand, setAriaExpand] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [billingData, setBillingData] = useState(billingDataProp);
  const [totalCost, setTotalCost] = useState(billingDataProp?.totalCost)
  const [taxCost, setTaxCost] = useState(billingDataProp?.taxCost)
  

  useEffect(() => {
    setBillingData(billingDataProp);
    setAriaExpand(false);
    setIsLoading(false);
    setTotalCost(billingDataProp?.totalCost)
    setTaxCost(billingDataProp?.taxCost)
  }, [bookingId,billingData]);


  const fetchBilling = async () => {
    try {
      setIsLoading(true);
      const data = await BreathAPIs.getBilling(bookingId);
      setBillingData(data.data);
      setTaxCost(data.data?.taxCost ? data.data?.taxCost : 0)
      setTotalCost(data.data?.totalCost)
    } catch (error) {
      console.error('Error fetching billing data:', error);
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    if (ariaExpand) {
      // fetchBilling();
      // console.log('fetching billing data...');
    }
  }, [ariaExpand]);



  function convertSecondsToHoursAndMinutes(totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const remainingSeconds = totalSeconds % 3600;
      const minutes = Math.floor(remainingSeconds / 60);
      return `${hours} h ${minutes} m`;
  }
// console.log("Billing DAT", billingData);
  return (
    <div className={styles['billing-block']}>
      <button onClick={() => setAriaExpand(!ariaExpand)} className={styles['expand-button']}>
        {ariaExpand ? <FiMinus /> : <FaPlus />}cost
      </button>
      {(ariaExpand && isLoading && billingData === null) && (
        <p className={`card-text placeholder-wave ${styles['loading']}`}>
          <span className="placeholder col-12"></span>
        </p>
      )}

      {(ariaExpand && !isLoading && billingData !== null) && (
        <div className={styles['data']}>
          <div className={styles['data-row']}>Utilized Energy <span>{billingData?.utilizedEnergy ? billingData?.utilizedEnergy?.toFixed(4) : '0.0000'} kWh</span></div>
          <div className={styles['data-row']}>Utilized Time <span>{billingData?.utilizedTime?.total ? convertSecondsToHoursAndMinutes(billingData?.utilizedTime?.total) : '0 h'}</span></div>
          {/* <div className={styles['data-row']}>Total Paid Consumed Energy <span>{billingData?.totalPaidConsumedEnergy ? billingData?.totalPaidConsumedEnergy : 0} kWh</span></div>
          <div className={styles['data-row']}>Total Free Consumed Energy <span>{billingData?.totalFreeConsumedEnergy ? billingData?.totalFreeConsumedEnergy : 0} kWh</span></div> */}
          {/* <div className={styles['data-row']}>Tax <span>${'0.00'}</span></div> */}
          <div className={styles['data-row']}>Unutilized Time <span>{unUtilizedTimeSec ? ((unUtilizedTimeSec - 10*60) > 0 ? convertSecondsToHoursAndMinutes(unUtilizedTimeSec - 10*60) : '0 h') : '0 h'}</span></div>
          <div className={styles['data-row']}>Idle Time <span>{idleDuration?.toFixed(2)} m</span></div>
          <div className={styles['data-row']}>
            <span style={{fontWeight:'400'}}>

            Energy Cost 
           
            </span>
           <span>
           <Button
              icon={<CopyOutlined />}
              onClick={() => navigator.clipboard.writeText((totalCost - unUtilizedFee - taxCost) || 0)}
              style={{ marginLeft:8, marginRight:8}}
              size="small"
              />
            ${(totalCost - unUtilizedFee - taxCost)?.toFixed(2)}
            </span>
          
            
            </div> {/* {(totalCost - unUtilizedFee - taxCost).toFixed(2)} */}
          <div className={styles['data-row']}>
            <span style={{fontWeight:'400'}}>
            Unutilized Time Fee 
           
            </span>
          <span>
          <Button
            icon={<CopyOutlined />}
            onClick={() => navigator.clipboard.writeText(unUtilizedFee || 0)}
            style={{ marginLeft: 8, marginRight:8 }}
            size="small"
        /> 
            ${unUtilizedFee?.toFixed(2)}
            </span></div>
          <div className={styles['data-row']}>
            <span style={{fontWeight:'400'}}>
            Idle Fee
           
              </span> <span> <Button
                                icon={<CopyOutlined />}
                                onClick={() => navigator.clipboard.writeText(billingData?.IdleCost ? billingData?.IdleCost : 0)}
                                style={{ marginLeft: 8, marginRight:8 }}
                                size="small"
                            />  ${billingData?.IdleCost ? billingData?.IdleCost?.toFixed(2) : '0.00'}
         
            </span></div>
          <div className={styles['data-row']}>
            <span style={{fontWeight:'400'}}>
            Tax
            ({billingData?.taxPercent ? billingData.taxPercent : '0'} %) 
            
                           
              </span><span>
              <Button
                                icon={<CopyOutlined />}
                                onClick={() => navigator.clipboard.writeText(billingData?.taxCost ? billingData.taxCost: 0.00)}
                                style={{ marginLeft: 8 , marginRight:8}}
                                size="small"
                            />
                
                
                ${billingData?.taxCost ? billingData.taxCost?.toFixed(2) : '0.00'} </span></div>

          <div className={`${styles['data-row']} ${styles['big']}`}>
            <span style={{fontWeight:'400'}}>
            Total Paid
          

              </span> <span>
              <Tooltip title="Copy Cost">
                            <Button
                                icon={<CopyOutlined />}
                                onClick={() => navigator.clipboard.writeText(billingData?.grandTotal ? billingData.grandTotal : 0.00)}
                                style={{ marginLeft: 8, marginRight:8 }}
                                size="small"
                            />
                        </Tooltip>
                
                ${billingData?.grandTotal ? billingData.grandTotal.toFixed(2): 0.00}
          
                        </span>
          </div>
        </div>
      )}

    </div>
  );
};

export default BillingBlock;
